<template>
  <ProcedureAccessDlg ref="access" />

  <Card>
    <div>

    <div class="cardTitle">
      {{ $t(title) }}
      <v-icon :icon="titleIcon"/>
    </div>
    <div
      v-if="!view"
      class="cardSubTitle"
    >
      {{ $t(subTitle) }}
    </div>
    <div
      v-if="allowedContragents.length > 0"
      class="d-flex flex-column suppliers-wrapper mt-4 mb-3"
    >
      <span class="title">{{ $t(`Приглашенные участники ({_1})`, {'_1': allowedContragents.length}) }}</span>
      <v-expansion-panels flat>
        <template v-for="(contragent, index) in allowedContragents" :key="index">
          <v-expansion-panel>
            <template #title>
              <div class="title d-flex justify-space-between w-100 align-center">
                <span>{{ contragent.fullName }}</span>
                <v-menu
                  transition="slide-x-transition"
                  location="bottom right"
                >
                  <template v-slot:activator="{ props }">
                    <v-btn
                      variant="text"
                      v-bind="props"
                      icon="mdi-dots-vertical"
                    />
                  </template>

                  <v-list class="py-0">
                    <v-list-item
                      @click="viewContragent(contragent.id)"
                      class="px-4"
                    >
                      <v-list-item-title>{{ $t('Просмотреть') }}</v-list-item-title>
                    </v-list-item>

                    <v-list-item
                      v-if="!hasActiveApplication(contragent.id) && !view"
                      @click="removeContragent(contragent.id)"
                      class="px-4"
                    >
                      <v-list-item-title class="text-error">{{ $t('Удалить') }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
            <v-expansion-panel-text>
              <div class="d-flex flex-column ga-1">
                <span class="subtitle">{{ `${contragent.inn} / ${contragent.kpp}` }}</span>
                <span class="subtitle">{{ contragent.email }}</span>
              </div>
            </v-expansion-panel-text>
          </v-expansion-panel>
          <v-divider
            class="divider"
          ></v-divider>
        </template>
      </v-expansion-panels>
    </div>
    <v-card-actions
      v-if="!view"
      style="padding: 0"
    >
      <v-btn
        variant="flat"
        size="x-small"
        class="greyButton"
        rounded
        @click="onAccess()"
      >{{ $t('Настроить доступ') }}</v-btn>
    </v-card-actions>
    </div>

  </Card>
</template>

<script>
import Card from "@intec/vue-components/form/Card.vue";
import Input from "@intec/vue-components/form/Input.vue";
import ProcedureAccessDlg from "@/components/dialogs/procedure/ProcedureAccessDlg.vue";
import { PROCEDURE_ACCESS_TYPE } from "@/lib/procedure";

export default {
  name: 'OpenCloseInfo',
  components: {
    ProcedureAccessDlg,
    Card,
    Input
  },
  props: {
    view: {
      type: Boolean,
      default: false,
    },
    isClosed: {
      type: Boolean,
      default: false,
    },
    allowedContragents: {
      type: Array,
      default: () => [],
    },
    applications: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update:isClosed', 'update:allowedContragents'],
  methods: {
    async onAccess() {
      const { confirmed, data } = await this.$refs.access.open(
        'Доступ к процедуре',
        this.isClosed,
        this.allowedContragents,
        this.applications,
      );

      if (confirmed) {
        this.$emit('update:isClosed', data.isClosed);
        this.$emit('update:allowedContragents', data.allowedContragents);
      }
    },
    viewContragent(contragentId) {
      let route = this.$router.resolve({
        name: 'profile.contragent',
        params: { id: contragentId },
        query: { backRoute: this.$route.fullPath }
      });
      window.open(route.href, '_blank');
    },
    removeContragent(contragentId) {
      const updated = this.allowedContragents.filter(
        contragent => contragent.id !== contragentId
      );
      this.$emit('update:allowedContragents', updated);
    },
    hasActiveApplication(contragentId) {
      return this.applications.some(app => app.contragentId === contragentId);
    },
  },
  computed: {
    title() {
      return (this.isClosed ? PROCEDURE_ACCESS_TYPE.TYPE_CLOSED : PROCEDURE_ACCESS_TYPE.TYPE_OPEN) + ' ' + this.$t('процедура');
    },
    titleIcon() {
      return 'custom:' + (this.isClosed ? 'closedLockIcon' : 'openLockIcon');
    },
    subTitle() {
      return 'Настройте доступ к процедуре: выберите открытую ' +
      '(для всех участников, с возможностью отправки приглашения) или закрытую (для ограниченного круга лиц).';
    }
  }
}

</script>

<style scoped>
.v-btn {
  border-radius: 6px !important;
}
.v-icon {
  margin-bottom: 10px;
}

.suppliers-wrapper {
  font-size: 14px;
  font-weight: 500;

  .title {
    font-size: 16px;
  }

  .subtitle {
    color: rgb(var(--unactive-text-color));
  }

  .divider {
    border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  }

  :deep(.v-expansion-panel-text__wrapper) {
    padding: 8px 24px;
  }

  :deep(.v-expansion-panel-title),
  :deep(.v-expansion-panel-title--active) {
    height: 40px;
  }
}

.cardSubTitle {
  font-size: 10px;
}

.greyButton {
  background-color: rgb(var(--quantity-round));
  color: rgb(var(--intec-primary-color));
}
</style>
